import { checkPermissions } from '@sharedInterfaces/IPermissions';
import getOrgUnit from '@src/APIs/graphQl/OrgUnit/getOrgUnit';
import OrgUnitPage from '@src/App/Pages/EntityPages/OrgUnits/OrgUnitPage/OrgUnitPage';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';

import Overlay from '../Overlay/Overlay';
import './OrgUnitOverlay.css';

interface OrgUnitOverlayProps {
    id: number;
    children: React.ReactNode;
    disabled?: boolean;
}

function OrgUnitOverlay(props: OrgUnitOverlayProps) {
    const orgUnit = useSelector((state: AppState) => state.orgUnits.find((ou) => ou.id === props.id));
    const permissions = useSelector((state: AppState) => state.permissions);
    const isAllowed =
        checkPermissions('OrgUnits', 'Retrieve', permissions) ||
        checkPermissions('OrgUnits', 'RetrieveOwn', permissions);
    const disabled = !isAllowed || props.disabled;
    const [error, setError] = React.useState<Error | null>(null);

    return (
        <Overlay
            disabled={disabled}
            triggerItem={props.children}
            loaded={orgUnit !== null}
            error={error}
            onFirstOpen={() => {
                getOrgUnit(props.id).catch(setError);
            }}
        >
            {orgUnit && <OrgUnitPage entity={orgUnit} inDialog={true} />}
        </Overlay>
    );
}

export default OrgUnitOverlay;
